module.exports = __webpack_public_path__ + "img/approved.2af467e5.png";